import { useEffect, useState } from "react";
import { Plus, MapPin } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Page, Spinner } from "@/components/shared";

const SERVICE_OPTS = ["Water", "Charging", "First Aid", "Medical", "Security", "Transit", "Rest Area", "Meeting Point", "Support Staff"];

export default function SafePointsAdmin() {
  const [pts, setPts] = useState(null);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [hours, setHours] = useState("10 AM – 10 PM");
  const [services, setServices] = useState([]);
  const [type, setType] = useState("meeting");

  const load = () => api.get("/band/safe-points").then(({ data }) => setPts(data));
  useEffect(() => { load(); }, []);

  const toggle = (s) => setServices((x) => (x.includes(s) ? x.filter((y) => y !== s) : [...x, s]));

  const add = async () => {
    if (!name) { toast.error("Add a name"); return; }
    await api.post("/band/safe-points", { name, hours, services, type, distance_km: 0.4, lat: 10.66, lng: -61.51 });
    toast.success("Safe Point added");
    setOpen(false); setName(""); setServices([]);
    load();
  };

  if (!pts) return <Spinner />;

  return (
    <Page>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-head font-extrabold text-3xl">Safe Points</h1>
          <p className="text-sm" style={{ color: "var(--cs-fg2)" }}>{pts.length} points active</p>
        </div>
        <button data-testid="safepoints-add-toggle" onClick={() => setOpen(!open)} className="cs-tap magenta-grad rounded-xl px-4 py-2.5 text-white font-semibold text-sm flex items-center gap-2">
          <Plus size={18} /> Add
        </button>
      </div>

      {open && (
        <div className="cs-card p-5 mt-5 rise">
          <input data-testid="safepoints-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Safe Point name"
            className="w-full rounded-xl px-4 outline-none mb-3" style={{ height: 48, background: "var(--cs-card-hi)", border: "1px solid var(--cs-border)", color: "#fff" }} />
          <input data-testid="safepoints-hours" value={hours} onChange={(e) => setHours(e.target.value)} placeholder="Operating hours"
            className="w-full rounded-xl px-4 outline-none mb-3" style={{ height: 48, background: "var(--cs-card-hi)", border: "1px solid var(--cs-border)", color: "#fff" }} />
          <p className="text-xs font-bold mb-2" style={{ color: "var(--cs-fg2)" }}>SERVICES</p>
          <div className="flex flex-wrap gap-2 mb-3">
            {SERVICE_OPTS.map((s) => (
              <button key={s} onClick={() => toggle(s)} className="cs-tap text-xs rounded-full px-3 py-1.5"
                style={{ background: services.includes(s) ? "var(--cs-magenta)" : "var(--cs-card-hi)", color: "#fff", border: "1px solid var(--cs-border)" }}>{s}</button>
            ))}
          </div>
          <button data-testid="safepoints-save" onClick={add} className="cs-tap w-full magenta-grad rounded-xl text-white font-bold" style={{ height: 48 }}>Save Safe Point</button>
        </div>
      )}

      <div className="grid sm:grid-cols-2 gap-4 mt-5">
        {pts.map((p) => (
          <div key={p.id} data-testid={`leader-safepoint-${p.id}`} className="cs-card p-4">
            <div className="flex items-center justify-between">
              <p className="font-head font-bold flex items-center gap-2"><MapPin size={18} style={{ color: "var(--cs-magenta)" }} /> {p.name}</p>
              <span className="text-xs rounded-full px-2 py-0.5" style={{ background: "rgba(16,185,129,0.15)", color: "var(--cs-green)" }}>{p.status || "open"}</span>
            </div>
            <p className="text-xs mt-1" style={{ color: "var(--cs-fg2)" }}>{p.hours}</p>
            <div className="flex flex-wrap gap-1.5 mt-2">
              {p.services.map((s) => <span key={s} className="text-[11px] rounded-full px-2 py-0.5" style={{ background: "var(--cs-card-hi)", color: "var(--cs-fg2)" }}>{s}</span>)}
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
}
